



















import { Vue, Component, Prop } from 'vue-property-decorator';

import {
  IMarketingCenterFormat,
  EMarketingCenterFormats
} from '@/models/marketingCenter/format';

import MarketingCenterCanvas from '@/components/organisms/MarketingCenterCanvas/MarketingCenterCanvas.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';

@Component({
  components: {
    MarketingCenterCanvas,
    Typography
  }
})
export default class FormatSelector extends Vue {
  @Prop({ required: true }) formats!: IMarketingCenterFormat[];
  @Prop({ required: true }) value!: EMarketingCenterFormats;

  getImgSrc(slug: EMarketingCenterFormats) {
    return require(`@/assets/img/marketingCenter/formats/${slug}.svg`);
  }
}
